import { Text } from "@/components/ui/text";
import { useAuth } from "@/hooks/useAuth";
import { navigationStateManager } from "@/utils/navigation/navigationState";
import { T } from "@transifex/react";
import { Redirect } from "expo-router";
import { memo, useEffect } from "react";
import { InfiniteProgress } from "../shared/InfiniteProgress";
import { Box } from "../ui/box";
import { Center } from "../ui/center";

const ProtectedRoute = memo(({ children }: { children: React.ReactNode }) => {
  const { user, isLoading } = useAuth();

  useEffect(() => {
    // Mark navigation as in transition when the protected route mounts
    navigationStateManager.startTransition();
    return () => {
      // Reset navigation state when unmounting
      navigationStateManager.endTransition();
    };
  }, []);

  if (isLoading) {
    return (
      <Box className="flex-1">
        <Center className="flex-1 gap-[32px] pb-[52px] pt-[44px] px-[20px]">
          <Text className="font-bold text-lg text-typography-900 text-center">
            <T _str="Checking auth..." />
          </Text>
          <InfiniteProgress className="w-3/4" />
        </Center>
      </Box>
    );
  }

  if (!user) {
    return <Redirect href="/auth/sign-in" />;
  }

  return <>{children}</>;
});

ProtectedRoute.displayName = "ProtectedRoute";

export default ProtectedRoute;
